import { InvoiceCoreBase } from "./invoice.core.base"


export class InvoiceCore extends InvoiceCoreBase {

}